import { FireIcon, GlobeAltIcon, MapPinIcon } from '@heroicons/react/24/outline';
import { memo } from 'react';
import { MapStyle, ViewMode } from './ClinicMapView';

interface MapControlsProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  mapStyle: MapStyle;
  setMapStyle: (style: MapStyle) => void;
}

const MapControls = ({ viewMode, setViewMode, mapStyle, setMapStyle }: MapControlsProps) => {
  return (
    <>
      {/* View Mode Toggle */}
      <div className="flex rounded-lg border border-gray-300 bg-white shadow-md">
        <button
          onClick={() => setViewMode('markers')}
          className={`flex items-center gap-1.5 rounded-l-lg px-3 py-2 text-sm font-medium transition-all ${
            viewMode === 'markers' ? 'bg-primary-500 text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
          title="Marker view"
        >
          <MapPinIcon className="h-4 w-4" />
          <span className="hidden sm:inline">Markers</span>
        </button>
        <button
          onClick={() => setViewMode('heatmap')}
          className={`flex items-center gap-1.5 rounded-r-lg border-l border-gray-300 px-3 py-2 text-sm font-medium transition-all ${
            viewMode === 'heatmap' ? 'bg-orange-500 text-white' : 'text-gray-600 hover:bg-gray-50'
          }`}
          title="Heatmap view"
        >
          <FireIcon className="h-4 w-4" />
          <span className="hidden sm:inline">Heatmap</span>
        </button>
      </div>

      {/* Map Style Switcher */}
      <div className="relative">
        <select
          value={mapStyle}
          onChange={e => setMapStyle(e.target.value as MapStyle)}
          className="appearance-none rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-8 text-sm font-medium text-gray-700 shadow-md hover:bg-gray-50 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
        >
          <option value="street">Street</option>
          <option value="satellite">Satellite</option>
          <option value="terrain">Terrain</option>
          <option value="dark">Dark</option>
        </select>
        <GlobeAltIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-500" />
        <svg
          className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </>
  );
};

export default memo(MapControls);
